module.exports = __webpack_public_path__ + "img/70022.40ba320e.png";